/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


export class GetAwsPrivateLinkStatusResponse {
  /**
  * Current state of the AWS PrivateLink setup.
  */
  'status': GetAwsPrivateLinkStatusResponseStatusEnum;
  /**
  * AWS RAM Resource Share ARN used to share the backed-up resource with Eon.
  */
  'ramShareArn'?: string | null;
  /**
  * Timestamp of the last state update.
  */
  'updatedAt'?: Date | null;
  /**
  * If applicable, when PrivateLink tear down started on Eon\'s side.
  */
  'tearDownStartedAt'?: Date | null;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "status",
      "baseName": "status",
      "type": "GetAwsPrivateLinkStatusResponseStatusEnum",
      "format": ""
    },
    {
      "name": "ramShareArn",
      "baseName": "ramShareArn",
      "type": "string",
      "format": ""
    },
    {
      "name": "updatedAt",
      "baseName": "updatedAt",
      "type": "Date",
      "format": "date-time"
    },
    {
      "name": "tearDownStartedAt",
      "baseName": "tearDownStartedAt",
      "type": "Date",
      "format": "date-time"
    }  ];

  static getAttributeTypeMap() {
    return GetAwsPrivateLinkStatusResponse.attributeTypeMap;
  }

  public constructor() {
  }
}


export enum GetAwsPrivateLinkStatusResponseStatusEnum {
  NotSetup = 'not_setup',
  InProgress = 'in_progress',
  Active = 'active',
  TearingDown = 'tearing_down'
}

